import { Box, Stack } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useNavigate } from 'react-router-dom'
import { useCallback, useState } from 'react'
import OverviewValue from '../screener/OverviewValue'
import { ScreenerField } from '../../proto/generated/screener'
import { navigateToIndustryLevel, isClassificationFieldCode } from '../../util/industryNavigation'

export type IndustryClassificationLinkProps = {
    securityCode: string
    fieldCode: string
    fieldData: ScreenerField | undefined
    value: string
    overview?: boolean
    isSecurityOverview?: boolean
}

export default function IndustryClassificationLink({
    securityCode,
    fieldCode,
    fieldData,
    value,
    overview = false,
    isSecurityOverview = false
}: IndustryClassificationLinkProps) {
    const navigate = useNavigate()
    const [navigating, setNavigating] = useState(false)

    const handleNavigate = useCallback(async () => {
        if (!isClassificationFieldCode(fieldCode) || navigating) return
        setNavigating(true)
        try {
            await navigateToIndustryLevel(securityCode, fieldCode, navigate)
        } finally {
            setNavigating(false)
        }
    }, [fieldCode, navigate, navigating, securityCode])

    if (!value || value === 'null') {
        return <span>-</span>
    }

    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="flex-start"
            gap={0.5}
            sx={{
                cursor: 'pointer',
                width: '100%',
                '&:hover': { textDecoration : "underline" },
                
            }}
            onClick={handleNavigate}
        >
            <OverviewValue overview={overview} fieldData={fieldData} text={value} />
            {isSecurityOverview && 
                <Box
                    className="industry-nav-icon"
                    component="span"
                    sx={{
                        display: 'inline-flex',
                        fontSize: 14,
                    }}
                >
                    <OpenInNewIcon sx={{ fontSize: 14 }} />
                </Box>
            }
        </Stack>
    )
}
